export default function Git_Quiz() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git Quiz</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/quiz</p>
    </div>
  );
}
